var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleteTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16692_8627)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 9,
    fill: "#00862E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.852 25.0176C34.0816 25.6098 33.7602 26.0154 33.1385 26.4156C32.6369 26.7375 31.998 27.0872 31.321 27.6843C30.6568 28.2696 30.0093 28.975 29.4337 29.6692C28.9412 30.2652 28.4723 30.8802 28.0282 31.513C27.8061 31.8301 27.4955 32.3032 27.4955 32.3032C27.384 32.4754 27.2305 32.6164 27.0494 32.7128C26.8684 32.8092 26.6657 32.8578 26.4606 32.8542C26.2557 32.853 26.0544 32.7993 25.876 32.6984C25.6976 32.5974 25.548 32.4525 25.4414 32.2775C24.9055 31.3778 24.4924 31.0222 24.3025 30.895C23.7944 30.5528 23.1979 30.5034 23.1979 29.7073C23.1979 29.0748 23.7317 28.5625 24.3899 28.5625C24.855 28.5797 25.2869 28.7626 25.6699 29.0201C25.9145 29.1843 26.1736 29.4021 26.4429 29.688C26.8038 29.1955 27.1792 28.7137 27.5684 28.2433C28.1891 27.4949 28.9219 26.6919 29.7078 25.9988C30.4803 25.3175 31.3735 24.6796 32.3204 24.3427C32.9373 24.1228 33.6229 24.4248 33.852 25.0176Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16692_8627",
    x: 0.887499,
    y: 0.887499,
    width: 54.225,
    height: 54.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.05625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.6 0 0 0 0 0.0862745 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16692_8627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16692_8627",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteTick);
export default __webpack_public_path__ + "static/media/completeTick.bff22035c846957916bf9130aa8faa20.svg";
export { ForwardRef as ReactComponent };